import styled from 'styled-components';

const Img = styled.img`
  width: 100%;
  max-width: 100%;
  vertical-align: middle;
`;

export default Img;
